<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MIT -->

<div class="technical-activities position-relative">
  <ng-container *ngIf="state$ | async as state">
    <ngx-spinner
      type="ball-clip-rotate"
      [fullScreen]="false"
      name="technicalActivitiesSpinner"
      color="rgba(0,0,0,0.5)"
      bdColor="rgba(255,255,255,0.5)"
      size="default"
    ></ngx-spinner>
    <div
      *ngIf="state === 'EMPTY' || state === 'ERROR'"
      class="lf-empty-data-message"
    >
      {{ noDataMessage }}
    </div>
    <div
      *ngIf="state === 'SUCCESS' || (userTechnicalRow.length && state === 'LOADING')"
    >
      <div class="d-flex gap-5 my-3">
        <lfx-lf-metric
          *ngFor="let metric of metrics"
          [value]="metric.value"
          [description]="metric.description"
          hidePercentage="true"
          size="xxs"
        ></lfx-lf-metric>
      </div>
      <div class="chart-area">
        <lfx-line-echarts
          [fnTableRowsMap]="technicalRowMap"
          [chartData]="userTechnicalRow"
          yAxisName="# of Contributions"
          [useQuarter]="useQuarter"
        ></lfx-line-echarts>
      </div>
    </div>
  </ng-container>
</div>
